import { render, staticRenderFns } from "./WkFormItem.vue?vue&type=template&id=01b26c4b&scoped=true&"
import script from "./WkFormItem.vue?vue&type=script&lang=js&"
export * from "./WkFormItem.vue?vue&type=script&lang=js&"
import style0 from "./WkFormItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WkFormItem.vue?vue&type=style&index=1&id=01b26c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b26c4b",
  null
  
)

component.options.__file = "WkFormItem.vue"
export default component.exports